var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "space-y-6 border-t border-gray-200 pt-6",
      attrs: { id: "approval-form" }
    },
    [
      _c("h2", { staticClass: "text-lg font-medium text-gray-900" }, [
        _vm._v("Configuración de Aprobación")
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _vm._m(0),
              _c("b-form-checkbox", {
                staticClass: "h-4 w-4 text-blue-600 border-gray-300 rounded",
                attrs: { type: "checkbox", switch: "", inline: "" },
                model: {
                  value: _vm.state.isPrivate,
                  callback: function($$v) {
                    _vm.$set(_vm.state, "isPrivate", $$v)
                  },
                  expression: "state.isPrivate"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "col-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "label",
                { staticClass: "block text-sm font-medium text-gray-700 mb-2" },
                [_vm._v(" Ejecutar como persona que lanza el evento ")]
              ),
              _c("b-form-checkbox", {
                staticClass: "mr-0",
                attrs: {
                  name: "is-vertical-menu-collapsed",
                  switch: "",
                  inline: ""
                },
                model: {
                  value: _vm.state.fromOrigingUser,
                  callback: function($$v) {
                    _vm.$set(_vm.state, "fromOrigingUser", $$v)
                  },
                  expression: "state.fromOrigingUser"
                }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c(
            "label",
            { staticClass: "block text-sm font-medium text-gray-700 mb-2" },
            [_vm._v(" Nombre (*) ")]
          ),
          _c(
            "Taggeable",
            { attrs: { keys: ["{{"], items: _vm.tags } },
            [
              _c("b-form-textarea-tags", {
                staticClass:
                  "w-full px-3 py-2 border border-gray-300 rounded-lg",
                attrs: {
                  type: "text",
                  placeholder: "Ingrese el nombre",
                  maxlength: "300",
                  tags: _vm.tags,
                  rows: "1"
                },
                model: {
                  value: _vm.state.name,
                  callback: function($$v) {
                    _vm.$set(_vm.state, "name", $$v)
                  },
                  expression: "state.name"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c(
            "label",
            { staticClass: "block text-sm font-medium text-gray-700 mb-2" },
            [_vm._v(" Descripción (*) ")]
          ),
          _c(
            "Taggeable",
            { attrs: { keys: ["{{"], items: _vm.tags } },
            [
              _c("b-form-textarea-tags", {
                staticClass:
                  "w-full px-3 py-2 border border-gray-300 rounded-lg",
                attrs: {
                  type: "text",
                  placeholder: "Ingrese descripción",
                  maxlength: "500",
                  tags: _vm.tags,
                  rows: "2"
                },
                model: {
                  value: _vm.state.description,
                  callback: function($$v) {
                    _vm.$set(_vm.state, "description", $$v)
                  },
                  expression: "state.description"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c(
            "label",
            { staticClass: "block text-sm font-medium text-gray-700 mb-2" },
            [_vm._v(" Flujo a utilizar (*) ")]
          ),
          _c("ListAprovals", {
            staticClass: "w-100 mb-0",
            attrs: {
              autocomplete: "",
              label: "",
              status: "Y",
              reference: "ARCHIVO,ARCHIVO-RP",
              name: "approvals",
              "data-vv-as": "flujo"
            },
            model: {
              value: _vm.state.flow,
              callback: function($$v) {
                _vm.$set(_vm.state, "flow", $$v)
              },
              expression: "state.flow"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "flex items-center space-x-3" }, [
      _c("span", { staticClass: "text-sm font-medium text-gray-700" }, [
        _vm._v("Es privado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }